module.exports = __webpack_public_path__ + "img/icon-4.dc34a364.png";